export default "__VITE_IMAGE_ASSET__0516eb84__";